<script setup>
import { onMounted } from 'vue'
import fiveMixin from '@/composables/fiveMixin'
import useFunctions from '@/composables/useFunctions'
import { DEV_MODE } from '@/config/dev-mode'
import { addContentLogAPI } from '@/api/logServiceApi'
const { ...five } = fiveMixin()
const { ...useFun } = useFunctions()

const emit = defineEmits()

const props = defineProps({
  prPgmode: {
    type: String,
    default: '',
  },
  prData: {
    type: Object,
    default: null,
  },
})
const PopShareBox = ref(true)
const PopSharePreviewBox = ref(false)

// 모바일 감지
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768
}

const close = () => {
  emit('close')
}
const closePreview = () => {
  PopSharePreviewBox.value = false
}

const openSharePreview = () => {
  PopSharePreviewBox.value = true
}

const KKOID = import.meta.env.VITE_KAKAO_APP_KEY
/* global Kakao */
onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
  // 카카오 SDK 초기화
  if (typeof Kakao !== 'undefined') {
    if (!Kakao.isInitialized()) {
      Kakao.init(KKOID)
    }
  } else {
    console.error('Kakao SDK가 로드되지 않았습니다.')
  }
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
const legacyCopyWithClipboardEvent = (text) => {
  let isCopied = false

  const onCopy = (event) => {
    if (!event?.clipboardData) return
    event.preventDefault()
    event.clipboardData.setData('text/plain', text)
    isCopied = true
  }

  try {
    document.addEventListener('copy', onCopy)
    const executed = document.execCommand('copy')
    return executed && isCopied
  } catch (error) {
    DEV_MODE && console.error('legacy copy event 실패:', error)
    return false
  } finally {
    document.removeEventListener('copy', onCopy)
  }
}

const fallbackCopyText = (text) => {
  try {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.setAttribute('readonly', 'readonly')
    textArea.style.position = 'fixed'
    textArea.style.left = '-9999px'
    textArea.style.top = '0'
    textArea.style.opacity = '0'
    document.body.appendChild(textArea)

    textArea.focus()
    textArea.select()
    textArea.setSelectionRange(0, text.length)

    const isCopied = document.execCommand('copy')
    document.body.removeChild(textArea)
    return isCopied
  } catch (error) {
    DEV_MODE && console.error('fallback copy 실패:', error)
    return false
  }
}

const copyShareText = async (text) => {
  const canUseClipboardApi =
    typeof window !== 'undefined' &&
    window.isSecureContext &&
    typeof navigator !== 'undefined' &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function'

  if (canUseClipboardApi) {
    await navigator.clipboard.writeText(text)
    return true
  }

  const isLegacyCopied = legacyCopyWithClipboardEvent(text)
  if (isLegacyCopied) return true

  return fallbackCopyText(text)
}

// 텍스트 복사 기능
const goCopy = async () => {
  addContentLogAPI({
    contentType: props.prPgmode === 'rs' ? 'sl_btn_share_select_opt3' : 'manse_btn_share_select_opt3',
    option3: '텍스트',
  })
  const shareData = useFun.convertShareTxt(props.prData)
  DEV_MODE && console.log('공유 데이터 형태:', props.prData)

  try {
    const isCopied = await copyShareText(shareData)
    if (isCopied) {
      alert('복사 되었습니다.')
      return
    }
    window.prompt('자동 복사에 실패했습니다. 아래 텍스트를 직접 복사해 주세요.', shareData)
  } catch (error) {
    window.prompt('자동 복사에 실패했습니다. 아래 텍스트를 직접 복사해 주세요.', shareData)
    DEV_MODE && console.error('복사 실패:', error)
  }
}

// 카카오 공유 기능
const goKko = () => {
  addContentLogAPI({
    contentType: props.prPgmode === 'rs' ? 'sl_btn_share_select_opt3' : 'manse_btn_share_select_opt3',
    option3: '카카오톡',
  })
  const shareData = useFun.convertShareTxt(props.prData)
  const frontUrl = import.meta.env.VITE_WEB_BASE_URL
  if (typeof Kakao !== 'undefined' && Kakao.isInitialized()) {
    Kakao.Share.sendDefault({
      objectType: 'text',
      text: shareData,
      link: {
        mobileWebUrl: frontUrl,
        webUrl: frontUrl,
      },
    })
  } else {
    console.error('Kakao SDK가 로드되지 않았습니다.')
  }
}
</script>
<template>
  <VDialog
  v-model="PopShareBox"
  class="v-dialog-sm dialog-st1"
  max-width="400px"
  @click:outside="close">
    <VCard class="br16">
      <div class="pop-inner" style="height: 360px">
        <div class="pop-tit-box tit-default">
          <div class="pop-tit-sub fnt16" style="text-align: center; width: 182px; ">사주정보 공유</div>
          <!-- <DialogCloseBtn variant="text" size="default" @click="close" /> -->
           <button class="dial-close" @click="close"></button>
        </div>
        <div class="pop-body pd-large-sh">
          <div class="pop-exp-sh">사주정보 결과를 복사하고, 공유 할 수 있는 기능입니다.</div>
          <div class="share-com-btn-box">
            <div class="" @click="goCopy()">
              <div class="icon-box">
                <i class="icon-message">붙여넣기아이콘</i>
              </div>
              <div class="txt1">텍스트 복사</div>
              <div class="txt2">원하는 곳에 붙여넣기<br />(Ctrl+V) 하여 사용하세요.</div>
            </div>
            <div class="" @click="goKko()">
              <div class="icon-box">
                <i class="icon-kko">카카오톡아이콘</i>
              </div>
              <div class="txt1">카카오톡 공유</div>
              <div class="txt2">카카오톡 친구&지인에게 <br />공유해보세요.</div>
            </div>
          </div>

          <div class="btn-guide-box">
            <button @click="openSharePreview()">
              <i class="icon-circle" /><span>공유 방법이 궁금하다면? <span class="pre-view">공유 내용 미리보기</span></span>
            </button>
          </div>
        </div>
      </div>
    </VCard>
  </VDialog>
  <VDialog
    v-model="PopSharePreviewBox"
    class="v-dialog-lg dialog-st1"
    :class="{ 'pop-share-preview-mobile': isMobile }"
    :max-width="isMobile ? '100%' : '640px'"
    :fullscreen="isMobile"
  >
    <VCard :class="isMobile ? '' : 'br16'">
      <div
        class="pop-inner center"
        :class="{ 'pop-preview-inner-mobile': isMobile }"
        :style="isMobile ? {} : { height: '642px', width: '640px', paddingTop: '20px' }"
      >
        <div class="pop-tit-box" :class="isMobile ? 'share-pre-tit-mobile' : 'share-pre'" style="margin-bottom: 16px;">
          <div class="pop-tit-sub fnt16" :style="isMobile ? { textAlign: 'center', flex: '1' } : { textAlign: 'center', width: '182px' }">공유 내용 미리보기</div>
          <!-- <DialogCloseBtn variant="text" size="default" @click="closePreview" /> -->
          <button class="dial-close" @click="closePreview" style="width: 24px; height: 24px;"></button>
        </div>
        <div class="pop-body" :class="isMobile ? 'share-pre-mobile' : 'share-pre'">
          <div class="share-preview-box-v2" :class="{ 'share-preview-box-v2-mobile': isMobile }">
            <div class="img01" />
            <div class="img02" />
          </div>
        </div>
      </div>
    </VCard>
  </VDialog>
</template>

<style lang="scss">
/* 공유 팝업 모바일 최적화 */

/* 미리보기 팝업 모바일 */
.pop-share-preview-mobile {
  .v-overlay__content {
    max-width: 100% !important;
    width: 100% !important;
  }
}

.pop-preview-inner-mobile {
  width: 100% !important;
  height: 100vh !important;
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pop-preview-inner-mobile .pop-tit-box {
  padding: 12px 16px !important;
  flex-shrink: 0;
}

.share-pre-tit-mobile {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  width: 100% !important;
  height: auto !important;
  padding: 0 !important;
  gap: 0 !important;

  .pop-tit-sub {
    width: auto !important;
  }

  .dial-close {
    position: absolute !important;
    right: 0 !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
}

.pop-body.share-pre-mobile {
  display: block;
  width: 100%;
  height: 0;
  flex: 1;
  padding: 0 !important;
  margin: 0 !important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.share-preview-box-v2-mobile {
  width: 100% !important;
  height: auto !important;
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 16px;
  padding: 0 !important;

  .img01,
  .img02 {
    width: 100% !important;
    max-width: 100%;
    height: 0 !important;
    padding-bottom: 120%;
    margin: 0 !important;
    background-size: 100% auto !important;
    background-position: center top !important;
    background-repeat: no-repeat !important;
  }
}
</style>
